/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { get } from '../../utils/ajax';

function getData(height) {
  return new Promise((resolve) => {
    get(`data/data.json`).then((e) => {
      resolve(JSON.parse(e));
    });
  });
}

// Create Thunk
export const fetchData = createAsyncThunk('fetchData', async (thunkAPI) => {
  const d = await getData();
  return d;
});

function selectOptions(data) {
  return data.map((item) => ({ value: item.id, label: item.name }));
}

// Slice
const data = createSlice({
  name: 'data',
  initialState: {
    data: [],
    id: null,
    options: [],
    loading: false,
  },
  reducers: {
    setId: (state, action) => {
      state.id = action.payload;
    },
    startLoading: (state) => {
      state.loading = true;
    },
    stopLoading: (state) => {
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchData.fulfilled, (state, action) => {
      state.data = action.payload;
      state.options = selectOptions(action.payload);
      state.loading = false;
    });
  },
});

export default data;
